import { useState, type FormEvent } from 'react';
import { ErrorState, Loading } from '../../components/States';
import { useAdminSkillVersions, useUploadAdminSkillVersion } from '../../hooks/api-hooks';
import { formatDateTime } from '../../lib/format';

export function AdminSkillContentPanel({ skillId, title, onClose }: { skillId: string; title: string; onClose: () => void }) {
  const versions = useAdminSkillVersions(skillId);
  const upload = useUploadAdminSkillVersion(skillId);
  const [version, setVersion] = useState('1.0.0');
  const [changelog, setChangelog] = useState('');
  const [file, setFile] = useState<File | null>(null);
  function submit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    if (!file) return;
    upload.mutate({ version, changelog, file }, { onSuccess: () => { setChangelog(''); setFile(null); } });
  }
  return <section className="admin-content-editor">
    <header><div><h2>File skill: {title}</h2><p>Mỗi lần cập nhật tạo một phiên bản mới trong vùng private của R2.</p></div><button type="button" className="btn btn-small btn-quiet" onClick={onClose}>Đóng</button></header>
    <form className="admin-inline-form" onSubmit={submit}>
      <input required value={version} onChange={(event) => setVersion(event.target.value)} placeholder="Phiên bản, ví dụ 1.1.0" />
      <input value={changelog} onChange={(event) => setChangelog(event.target.value)} placeholder="Nội dung thay đổi" />
      <input required type="file" onChange={(event) => setFile(event.target.files?.[0] ?? null)} />
      <button className="btn btn-small" disabled={upload.isPending || !file}>{upload.isPending ? 'Đang tải…' : 'Tải lên R2'}</button>
    </form>
    {upload.error && <ErrorState error={upload.error} />}
    {versions.isPending && <Loading />}{versions.error && <ErrorState error={versions.error} />}
    {versions.data && <div className="admin-version-list">{versions.data.map((item) => <div key={item.id}><strong>v{item.version}</strong><span>{item.fileName}</span><small>{formatDateTime(item.publishedAt)}</small></div>)}{!versions.data.length && <p className="muted">Chưa có file nào.</p>}</div>}
  </section>;
}
